export default "__VITE_ASSET__1f48cd88__"